/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Panel from '@adsk/alloy-react-panel';
import MemberFilterPanelContent from './components/MemberFilterPanelContent';
import MemberFilterPanelHeader from './components/MemberFilterPanelHeader';
import { panelBodyStyle } from './styles';

const MemberFilterPanel = ({
  accessLevelSearchInput,
  accessLevels,
  children,
  companies,
  companySearchInput,
  isFetchingCompanies,
  isFetchingRoles,
  onAccessLevelChange,
  onChangeAccessLevelInput,
  onChangeCompanyInput,
  onChangeRoleInput,
  onChangeStatusInput,
  onClose,
  onCompanyChange,
  onRoleChange,
  onStatusChange,
  open,
  roleSearchInput,
  roles,
  selectedAccessLevel,
  selectedCompany,
  selectedRole,
  selectedStatus,
  status,
  statusSearchInput,
  title,
}) => {
  const customHeader = () => {
    return <MemberFilterPanelHeader onClose={onClose} title={title} />;
  };

  return (
    <Panel open={open} renderHeader={customHeader}>
      <Panel.Body style={panelBodyStyle}>
        <MemberFilterPanelContent
          accessLevelSearchInput={accessLevelSearchInput}
          accessLevels={accessLevels}
          companies={companies}
          companySearchInput={companySearchInput}
          isFetchingCompanies={isFetchingCompanies}
          isFetchingRoles={isFetchingRoles}
          onAccessLevelChange={onAccessLevelChange}
          onChangeAccessLevelInput={onChangeAccessLevelInput}
          onChangeCompanyInput={onChangeCompanyInput}
          onChangeRoleInput={onChangeRoleInput}
          onChangeStatusInput={onChangeStatusInput}
          onCompanyChange={onCompanyChange}
          onRoleChange={onRoleChange}
          onStatusChange={onStatusChange}
          roleSearchInput={roleSearchInput}
          roles={roles}
          selectedAccessLevel={selectedAccessLevel}
          selectedCompany={selectedCompany}
          selectedRole={selectedRole}
          selectedStatus={selectedStatus}
          status={status}
          statusSearchInput={statusSearchInput}
        />
        {children}
      </Panel.Body>
    </Panel>
  );
};

MemberFilterPanel.propTypes = {
  ...Panel.propTypes,
};

export default MemberFilterPanel;
